import { AppRouteConstants } from '@shared/core';

export const appRouteConstants: AppRouteConstants & {
    settings: string;
    policies: string;
    claims: string;
    contact: string;
    newClaim: string;
    newReportClaim: string;
    newRefundClaim: string;
    booking: string;
} = {
    login: '/login',
    registration: '/registration',
    error: '/error',
    main: '/main',
    home: '/main/home',
    settings: '/main/settings',
    policies: '/main/insurance-policies',
    claims: '/main/claims',
    contact: '/main/contact',
    newClaim: '/main/claims/create',
    newReportClaim: '/main/claims/create/report',
    newRefundClaim: '/main/claims/create/reimbursement',
    booking: '/main/book',
};
